/**
 * Map RefType với SubSystemCode
 * Mục đích tạo file này là để check quyền dựa vào RefType
 * dqvinh 26.4.2023
 * Key: SubsystemCode -  value: refType
 */
export default {
  BUTransfer: 56, // Chuyển khoản kho bạc vào TK tiền gửi
  BUTransfer_Temp1: 561, // Chuyển khoản kho bạc vào TK tiền gửi
  BuPlanWithDraw: 562, // Rút dự toán tiền gửi
  BuPlanWithDraw_Temp1: 54, // Rút dự toán tiền mặt
  BuPlanWithDraw_Temp2: 55, // Rút dự toán chuyển khoản
  BuPlanWithDraw_Temp3: 563, // Rút dự toán chuyển khoản lương, bảo hiểm
  BUPlanReceipt: [51, 52], //Nhận dự toán đầu năm  NOTE: 51 52 dùng chung form Detail đặt tên giống nhau
  CAReceiptPlanWithdraw: 105, // Phiếu thu rút dự toán nhập quỹ
  CAReceipt: 101, // Phiếu thu rút dự toán nhập quỹ
  CAReceiptSale: [102, 154], // Phiếu thu bán hàng
  CAReceipt_Temp1: 114, //Phiếu thu rút tiền gửi ngân hàng, kho bạc
  BUPlanCancel: 69, // Hủy dự toán,
  BUVoucherList: 63, // Bảng kê chứng từ thanh toán đã cấp dự toán
  BUVoucherList_Temp1: 64, // Bảng kê chứng từ thanh toán chưa cấp dự toán
  BUVoucherList_Temp2: 65, // Bảng kê chứng từ thanh toán ghi thu - ghi chi
  BUVoucherList_Temp3: 66, // Bảng kê chứng từ khác
  BUVoucherList_Temp4: 70, // Bảng kê chứng từ thanh toán thực chi
  BUPlanAdjustment: 53, //Điều chỉnh dự toán
  InventoryItemSutransfer: 207, // Điều chuyển CCDC
  InventoryItemSuincrement: 205, // Ghi tăng CCDC
  InventoryItemSudecrement: 206, // Ghi giảm CCDC
  BUPlanWDAdjustment: 652, // Điều chỉnh kinh phí
  PuInvoice: 301, // Mua hàng chưa thanh toán (Hóa đơn mua hàng)
  InTransfer: 203, // Chuyển kho
  InventoryInAjustment: 204, // Điều chỉnh tồn kho
  InventoryInOutward: 202, // Xuất kho
  InventoryInInward: 201, // Nhập kho
  BADeposit: 153, // Thu tiền gửi
  SAInvoice: 351, //Bán hàng chưa thu tiền
  BABankTransfer: 162, // Chuyển tiền nội bộ
  CAPayment: 106, //Phiếu chi thông thường
  CAPayment_Temp1: 113, // Phiếu chi nộp vào ngân hàng, kho bạc
  BAWithdraw: 157, // Chi tiền gửi
  BUBudgetReserve: 73, //Dự toán giữ lại
  GLVoucher: 401, // Chứng từ nghiệp vụ khác
  EndYearTransfer: 402, //Kết chuyển số dư cuối năm
  BeginningYearTransfer: 403, //Quyết toán số dư đầu năm
  CAReceiptCustom: [104, 156], //Phiếu thu tiền khách hàng
  GLProfitLossTransfer: 404, //Xác định kết quả hoạt động
  // GLProvisionalTaxInComeEnterpriseDetail: 420, //Tạm tính thuế thu nhập doanh nghiệp
  GLVoucher_Temp1: 421, //Quyết toán thuế thu nhập doanh nghiệp
  VoucherSummaryTable: 406, //Bảng tổng hợp chứng từ cùng loại
  SAReturn: 352, //Hàng bán trả lại
  BUCommitmentRequest: 71, // Đề nghị cam kết chi
  BUCommitmentRequest_Temp1: 72, // Điều chỉnh cam kết chi
  BUCommitmentRequest_Temp2: 606, // Nhập CKC ban đầu
  GLPostedVoucher: 407, // Chứng từ ghi sổ
  BATransferDeposit: 151, //Tiền đang chuyển đến
  BATransferWithdraw: 152, //Tiền đang chuyển đi
  QltsVoucher: 413, // Lấy hao mòn tự nhiên TSCĐ từ QLTS.VN
  QltsVoucher_Temp1: 410, // Ghi tăng TSCĐ từ QLTS.VN
  QltsVoucher_Temp2: 411, // Đánh giá lại TSCĐ từ QLTS.VN
  QltsVoucher_Temp3: 412, // Lấy khấu hao TSCĐ từ QLTS.VN
  QltsVoucher_Temp4: 414, // Ghi giảm TSCĐ từ QLTS.VN
  InventoryInInward_Temp1: 211, // nhập kho từ điều chỉnh tồn kho
  InventoryInInward_Temp2: 213, // nhập kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)
  InventoryInOutward_Temp1: 212, // xuất kho từ điều chỉnh tồn kho
  InventoryInOutward_Temp2: 214, // xuất kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)
  PUPayment: [57, 107, 158], // Mua hàng trả tiền ngay// CAPaymentPurchaseDetail: 107, // Phiếu chi mua Vật tư, hàng hóa// BAWithdrawPurchaseDetail: 158, // Chi tiền gửi mua Vật tư, hàng hóa
  BUTransfer_Temp2: 564, //Chuyển khoản lương
  BUTransfer_Temp3: 565, // Chuyển khoản thanh toán bảo hiểm
  PUVendorPayment: [59, 109, 160], //Trả tiền nhà cung cấp
  SASaleInvoice: 701, //Hóa đơn
  StatisticalDayOff: 501, //Tổng hợp ngày nghỉ, làm thêm làm đêm
  PARetroSalary: 509, // Bảng truy lĩnh lương
  PAOtherOutcome: 506, // Khấu trừ không thường xuyên
  OtherIncome: 505, // Thu nhập không thường xuyên
  Salary: 502, // bảng lương
  // OPBalance: [551, 552, 553, 554, 555, 556, 557, 558, 559, 601, 604, 605], //Số dư ban đầu
  BUTransfer_Temp4: 60, //Chuyển khoản kho bạc trả lương
  BAWithdraw_Temp1: 163, //Chi tiền gửi trả lương
  CAPayment_Temp2: 110, // phiếu chi trả lương
  // PAPersonalIncomeTaxDetail: 510, // Bảng tính thuế
  // GLPayrollExpenseDetail: 405, //Hạch toán chi phí lương
  FaAdjustment: 254, // Đánh giá lại TSCĐ
  FAIncrement: 252, // Nhận bằng hiện vật và ghi tăng
  FARevenue: 256, //Bán TSCĐ chưa thu tiền
  FADecrement: 253, // Đánh giá lại TSCĐ
  FAPurchaseIncrement: 251, // Mua TSCĐ cố định chưa thanh toán (Hóa đơn mua TSCĐ)
  FAPurchaseIncrement_Temp1: [58, 108, 159], //Chuyển khoản mua TSCĐ, Phiếu chi mua TSCĐ, Chi tiền gửi mua TSCĐ
  FADepreciation: 255, // Hao mòn TSCĐ
  FADevaluation: 419, // khấu hao TSCĐ
  FATransfer: 257, // Điều chuyển tài sản cố định
  FARevenue_Temp1: [103, 155], // Phiếu thu bán TSCĐ, Thu tiền gửi bán TSCĐ (dùng chung form detail)
  TACircularVATDeclaration: 469, // Tờ Khai giá trị gia tăng
  OpeningSupplyEntry: 602, // Nhập công cụ dụng cụ ban đầu
  // ReceiptDetail: 707, // biên lai
};
